export const FETCHING_MARKET = "FETCHING_MARKET";
export const FETCHING_MARKET_SUCCESS = "FETCHING_MARKET_SUCCESS";
export const FETCHING_MARKET_ERROR = "FETCHING_MARKET_ERROR";
